import { SPEAK_TYPE } from './constant.js';
import { speakElementToHtml } from './element-to-html.js';
import { speakHtmlToElement } from './html-to-element.js';
import { speakPlugin } from './plugin.js';
import { speakRenderElement } from './render-element.js';
import { speakSerializer } from './serializer.js';

const SpeakModule = {
  type: SPEAK_TYPE,
  renderElement: speakRenderElement,
  elementToHtml: speakElementToHtml,
  htmlToElement: speakHtmlToElement,
  plugin: speakPlugin,
  serializer: speakSerializer
};

export { SpeakModule };
//# sourceMappingURL=module.js.map
